// WhooLive Web Portal — environment configuration
// NOTE: During the design phase we use mock data only.
// The existing WhooLive mobile backend remains the source of truth.
// When ready, set REACT_APP_WHOOLIVE_API_URL and flip USE_MOCK to false.

export const ENV = {
  // Placeholder for the FUTURE public WhooLive API base URL.
  // Left intentionally empty during the mock/design phase.
  WHOOLIVE_API_URL: process.env.REACT_APP_WHOOLIVE_API_URL || "",

  // Master switch for the data layer. Keep true until real APIs are wired.
  USE_MOCK: (process.env.REACT_APP_USE_MOCK ?? "true") !== "false",

  // Simulated network latency (ms) so loading states feel real in mock mode.
  MOCK_LATENCY: 650,

  APP_NAME: "WhooLive",
};

export default ENV;
